/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Injectable } from "@angular/core";

// return the global native browser window object
const _window = (): any => window;

@Injectable({
  providedIn: "root",
})
export class WindowRef {
  get nativeWindow(): any {
    return _window();
  }
}
